import React from 'react';
import SocialMedia from './../social-media/SocialMedia';
import Facebook from './images/facebook.svg';
import Google from './images/g.svg';
import Intagram from './images/instagram.svg';
import Linked from './images/linked-in.svg';
import Twitter from './images/twitter.svg';
import Youtube from './images/you-tube.svg';
import './SocialMedias.css';


function SocialMedias() {
  const {
    REACT_APP_SM_FACEBOOK_HOST,
    REACT_APP_SM_GOOGLE_HOST,
    REACT_APP_SM_INSTAGRAM_HOST,
    REACT_APP_SM_LINKED_HOST,
    REACT_APP_SM_TWITTER_HOST,
    REACT_APP_SM_YOUTUBE_HOST,
  } = process.env;
  return (
    <ul className="socialMedias">
      <SocialMedia url={REACT_APP_SM_FACEBOOK_HOST} alt="Facebook" image={Facebook} />
      <SocialMedia url={REACT_APP_SM_GOOGLE_HOST} alt="Google" image={Google} />
      <SocialMedia url={REACT_APP_SM_INSTAGRAM_HOST} alt="Intagram" image={Intagram} />
      <SocialMedia url={REACT_APP_SM_LINKED_HOST} alt="Linked" image={Linked} />
      <SocialMedia url={REACT_APP_SM_TWITTER_HOST} alt="Twitter" image={Twitter} />
      <SocialMedia url={REACT_APP_SM_YOUTUBE_HOST} alt="Youtube" image={Youtube} />
    </ul>
  );
}


export default SocialMedias;
